<convfact-concept-form [empty]="empty" [accountsAndTaxes]="accountsAndTaxes" [concept]="concept" [families]="families"
  *ngIf="concept" [errors]="errors" (onSave)="saveData($event)"></convfact-concept-form>
